var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M5 13l4 4L19 7"}));
}

Checkmark.defaultProps = {"stroke":"currentColor","fill":"none","viewBox":"0 0 24 24"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
